import { TranslationKeys } from '~frontend-common/i18n/english/move-in-details.18n';

const keys: TranslationKeys = {
  moveInDetails: {
    subtitles: {
      previousAddress: {
        alreadyMovedIn: 'Quelle était votre adresse précédente?',
        notMovedIn: 'Quelle est votre adresse actuelle?',
      },
    },
    placeholders: {
      previousAddress: '500 Avenue des Pins, Montreal',
    },
    isInternationalAddress: {
      currently: 'Mon adresse actuelle est en dehors du Canada',
      previously: 'Mon adresse précédente est en dehors du Canada',
    },
  },
};

export default keys;
